import firebase from 'firebase/app';
import 'firebase/database';
export default class Model {
    constructor(ref, key){
        this.ref = ref;
        this.key = key;
        this.fillable = null;
        this.generatedKey = null;
    }

    get(){
        return new Promise((resolve, reject) => {
            firebase.database().ref(this.ref).once('value', object => {
                 resolve(object.val());
            }, error => {
                reject({message: "Failed to retrieve object", data: error});
            })
        })
    }
    save(){
        if(this.key){
            return new Promise((resolve, reject) => {
                firebase.database().ref(this.ref).set(this.fillable, error => {
                    if(error){
                        reject({message: "Failed to save object", data: error});
                    }else{
                        resolve(true);
                    }
                })
            });
        }else{
            return new Promise((resolve, reject) => {
                this.generatedKey = firebase.database().ref(this.ref).push().key;

                firebase.database().ref(this.ref +'/' + this.generatedKey).set(this.fillable, error => {
                    if(error){
                        reject({message: "Failed to save object", data: error});
                    }else{
                        resolve(true);
                    }
                })
            });
        }
    }

    update(specificFields = null){
        return new Promise((resolve, reject) => {
            let object = (specificFields) ? specificFields : this.fillable;
            firebase.database().ref(this.ref).update(object, (error) => {
                if(error){
                    reject("Failed to update record.")
                }else{
                    resolve(true);
                }
            })
        })
    }

}